import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/Avatar";
import { BodyText } from "@/components/ui/Text";
import { cn } from "@/lib/utils";
import type { ChatUser } from "../types/chatMessageTypes";
import { getUserDisplayName, getUserInitials } from "../utils/chatSenderUtils";

interface UserAvatarProps {
  user?: ChatUser;
  fallbackName?: string;
  fallbackInitials?: string;
  showName?: boolean;
  isCustomer?: boolean;
  size?: "sm" | "md";
  bgColor?: string;
  className?: string;
}

export const UserAvatar = ({
  user,
  fallbackName = "Unknown User",
  fallbackInitials = "?",
  showName = true,
  isCustomer = false,
  size = "sm",
  bgColor,
}: UserAvatarProps) => {
  const displayName = user ? getUserDisplayName(user) : fallbackName;
  const initials = user ? getUserInitials(user) : fallbackInitials;
  const photoUrl = user?.professional?.photo;

  const avatarSize = size === "sm" ? "h-6 w-6" : "h-8 w-8";

  return (
    <div className={cn("flex items-center")}>
      <Avatar className={cn(avatarSize, "mr-2")}>
        <AvatarImage src={photoUrl} alt={displayName} />
        <AvatarFallback
          className={cn(
            !bgColor && (isCustomer ? "bg-accent-primary" : "bg-primary-green"),
          )}
          style={bgColor ? { backgroundColor: bgColor } : {}}
        >
          <BodyText
            size="xs"
            textColor={isCustomer || bgColor ? "primary" : "white"}
          >
            {initials}
          </BodyText>
        </AvatarFallback>
      </Avatar>
      {showName && <BodyText size={size}>{displayName}</BodyText>}
    </div>
  );
};
